






















import { Component, Vue, Emit } from 'vue-property-decorator';
import { institutionServer } from '@/api/installServer';

@Component
export default class PatrolEquipSplit extends Vue {
  private visible = false;
  private form: any = {
    spaceId: '',
    patrolEquipIds: [],
  };
  private spaceList: any = [];
  private patrolEquipList: any = [];
  private splitRules: any = {
    spaceId: [{ required: true, message: '请输入空间名称', trigger: 'blur' }],
  };

  /**
   * 显示窗口
   */
  showDialog(data: any) {
    this.patrolEquipList = data;
    // 获取空间（企业）list（并且有验证是否超级管理员）
    this.getSpaceInfoByType('ent');
    this.visible = true;
  }

  /**
   * 关闭窗口
   */
  hideDialog() {
    this.resetForm();
    this.visible = false;
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    this.form.patrolEquipIds = [];
    const arrObj = this.patrolEquipList;
    arrObj.forEach((item: any) => {
      this.form.patrolEquipIds.push(item.id);
    });
    if (this.form.patrolEquipIds.length > 0) {
      // 分配巡检设备到空间
      this.splitPatrolEquipToSpace();
    } else {
      // 空巡检设备
      this.$message.warning('无选中的巡检设备。');
    }
  }

  /**
   *【表单】表单重置
   * @Params
   * @return
   **/
  resetForm() {
    const formComponent: any = this.$refs['form'];
    formComponent.resetFields();
  }

  /**
   * 标签去除
   */
  handleTagClose(id: string) {
    const arrObj = this.patrolEquipList;
    try {
      let i = 0;
      arrObj.forEach((item: any) => {
        if (item.id == id) {
          this.patrolEquipList.splice(i, 1);
          throw new Error();
        }
        i++;
      });
    } catch (e) {}
  }

  /**
   * 【接口】根据空间类型获取空间信息list
   * @param type
   */
  async getSpaceInfoByType(type: string) {
    this.form.loading = true;
    try {
      const res: any = await institutionServer.getCompanyList({});
      if (res.code === '200') {
        this.spaceList = res.data;
        this.form.loading = false;
      } else {
        this.$message.warning(res.msg);
        this.hideDialog();
      }
    } catch (e) {
      this.$message.warning('网络异常，请稍后重试。');
      throw new Error();
    }
  }

  /**
   * 【接口】分配巡检设备到空间
   */
  async splitPatrolEquipToSpace() {
    // console.log(this.form, 'form');
    // try {
    //   const res: any = await patrolManagementServe.splitOtherSpace({
    //     spaceId: this.form.spaceId,
    //     patrolEquipIds: this.form.patrolEquipIds,
    //   });
    //   if (res.code === '200') {
    //     this.hideDialog();
    //     this.onResponse();
    //     this.$message.success('分配成功。');
    //   } else if (res.response.status == 403) {
    //     this.$message.warning(res.response.data.msg);
    //     this.hideDialog();
    //   } else {
    //     this.$message.warning('网络异常，请稍后重试。');
    //     throw new Error();
    //   }
    // } catch (e) {
    //   switch (e.response.status) {
    //     case 403:
    //       this.$message.warning('权限错误');
    //       this.hideDialog();
    //       break;
    //   }
    //   throw new Error();
    // }
  }

  /**
   * 【广播】广播提交成功事件
   * @Params
   * @return
   **/
  @Emit('on-response')
  onResponse() {}
}
